const LIGHT_TEXT = "#FFFFFF";
const DARK_TEXT = "#000000";
const LIGHT_BACKGROUND = 155;

function readChannels(
  color: string,
): { red: number; green: number; blue: number } | null {
  const value = color.trim();

  if (value.startsWith("#")) {
    let hex = value.slice(1);
    if (hex.length === 3) {
      hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
    }
    if (hex.length < 6) {
      return null;
    }
    const red = parseInt(hex.slice(0, 2), 16);
    const green = parseInt(hex.slice(2, 4), 16);
    const blue = parseInt(hex.slice(4, 6), 16);
    if (Number.isNaN(red) || Number.isNaN(green) || Number.isNaN(blue)) {
      return null;
    }
    return { red, green, blue };
  }

  const match = value.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
  if (!match) {
    return null;
  }

  return {
    red: Number(match[1]),
    green: Number(match[2]),
    blue: Number(match[3]),
  };
}

export function textColorForBackground(color: string): string {
  const channels = readChannels(color);
  if (!channels) {
    return LIGHT_TEXT;
  }

  const brightness =
    (channels.red * 299 + channels.green * 587 + channels.blue * 114) / 1000;

  if (brightness > LIGHT_BACKGROUND) {
    return DARK_TEXT;
  }

  return LIGHT_TEXT;
}
